import type { Review } from '@integration/reviews-api-models';
import {
  GetReviewsResponseWithStatistics,
  GetReviewStatisticsResponse,
} from '@integration/reviews-api-models';

import type { ReviewsComponentRendering } from './reviews.model';

export const mockStats = GetReviewStatisticsResponse.fromPlain({
  averageRating: 8,
  totalReviews: 1000,
  recommendPercentage: 75,
});

export const mockReviews: Review[] = [
  {
    id: 'd17e6d87-2dbd-4bf1-bcb5-ab86a3147903',
    author: 'Michael ',
    city: 'Althoff',
    date: '2022-05-01T18:00:10.976Z',
    rating: 2,
    content:
      'Heel schlechte klantenservice, telefoon wordt gewoon neergelegd als zij geen goede antwoord hebben.\nProbleem ligt nooit bei Essent.',
    title: 'Mock review 1',
    wouldRecommend: false,
  },
  {
    id: '14045e05-2ac0-4020-9c6b-bce9e4b715ba',
    author: 'Lisette ',
    city: 'Waalre',
    date: '2022-05-02T12:08:33.214Z',
    rating: 3,
    content: 'slecht',
    title: 'Mock review 2 ',
    wouldRecommend: true,
  },
  {
    id: 'e1f22aa5-2b97-4c81-9378-52d6942a7068',
    author: '3814XM Amersfoort ',
    city: 'Amersfoort',
    date: '2022-04-30T10:10:37.16Z',
    rating: 10,
    content: 'Super, bedankt. Het was lekker gezellig, snel en makkelijk',
    title: 'Mock review 3',
    wouldRecommend: true,
  },
  {
    id: '02a52d1f-e93c-4dc6-8ddc-5b91aecf9532',
    author: 'Semsada Hadziomerov',
    city: 'Den Bosch',
    date: '2022-04-29T19:53:09.498Z',
    rating: 8,
    content: 'Goede service.',
    title: 'Mock review 4',
    wouldRecommend: true,
  },
];

export const mockReview = mockReviews[0];
export const mockReviewsAndStats = GetReviewsResponseWithStatistics.fromPlain({
  reviews: mockReviews,
  ...mockStats,
});

export const mockReviewRendering: ReviewsComponentRendering = {
  componentName: 'reviews',
  fields: {
    Title: {
      value: 'Hoe beoordelen klanten Essent?',
    },
    ButtonLink: {
      value: {
        href: '/alle-reviews',
        text: 'Bekijk alle reviews',
      },
    },
    ButtonText: {
      value: 'Meer reviews',
    },
    reviewCategory: {
      fields: {
        value: {
          value: 'emobility',
        },
      },
    },
  },
} as ReviewsComponentRendering;
